import { ReactNode } from "react";
import styles from "./FieldRow.module.css";

interface Props {
  name: ReactNode;
  apiName: string;
  hint?: ReactNode;
  children: ReactNode;
}

/**
 * Two-column field row (label + control) used throughout the Config page.
 *
 * Mockup: project-config.html L159-L165 — grid 220px / 1fr, dashed top
 * border between rows, label stack with human name + mono api-name + hint.
 * The dashed-divider behaviour lives in the parent SectionCard styles via
 * `.fieldRow + .fieldRow` so consumers don't need to thread an index in.
 */
export function FieldRow({ name, apiName, hint, children }: Props) {
  return (
    <div className={styles.fieldRow}>
      <div className={styles.label}>
        <div className={styles.name}>{name}</div>
        <div className={styles.apiName}>{apiName}</div>
        {hint && <div className={styles.hint}>{hint}</div>}
      </div>
      <div className={styles.input}>{children}</div>
    </div>
  );
}
